import {createAsyncAction} from 'typesafe-actions';
import {AxiosError} from 'axios';
import {IGetEditangleInfo} from 'lib/api/getEditangle';

export const GET_EDITANGLE = 'getEditangle/GET_EDITANGLE';
export const GET_EDITANGLE_SUCCESS = 'getEditangle/GET_EDITANGLE_SUCCESS';
export const GET_EDITANGLE_ERROR = 'getEditangle/GET_EDITANGLE_ERROR';

export const getEditangleAction = createAsyncAction(
  GET_EDITANGLE,
  GET_EDITANGLE_SUCCESS,
  GET_EDITANGLE_ERROR,
)<IGetEditangleInfo, IGetEditangleInfo, AxiosError>();
